import * as React from 'react';
import { Button, Icon, Input } from 'antd';
import { Header } from './layout';
import { ForecastDomainIcon } from '../Gmw-like-homepage/forecast-domain-icon';
import { Forecast } from '../../model/forecast';
import twoLineOeLogo from "../../content/OE-Logo - Main - Colour - RGB.png";
import "./gmwo-header.css";

interface GmwoHeaderControls {
    selectedForecast?: Forecast;
    userName: string;
    userCompany?: string;
    onSelectModel: () => void;
    onBrowseFiles: () => void;
    onLogout: () => void;
}

interface GmwoHeaderProps {
    /** Model picker, file browser and account controls; omitted on pages without a session (e.g. errors). */
    controls?: GmwoHeaderControls;
}

const userIcon = (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <circle cx="7" cy="4.8" r="2.8" stroke="rgba(255,255,255,0.7)" strokeWidth="1.4" />
        <path d="M1.5 13c0-2.8 2.2-4.5 5.5-4.5S12.5 10.2 12.5 13" stroke="rgba(255,255,255,0.7)" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

export function GmwoHeader({ controls }: GmwoHeaderProps) {
    return (
        <Header className="gmwo-header">
            <div className="gmwo-header-left">
                <img src={twoLineOeLogo} className="gmwo-header-logo" alt="Oxford Economics" />
            </div>
            <div className="gmwo-header-right">
                <div className="gmwo-header-controls">
                    <div className="gmwo-header-title-block">
                        <div role="heading" className="gmwo-header-title open-sans">
                            <span>Global Model Workstation Online</span>
                        </div>
                    </div>
                    {controls && <>
                        <div className="gmwo-header-model-input">
                            <Input
                                id="working-database"
                                aria-label="Economic model"
                                className="gmwo-header-input"
                                placeholder="Please select working model ..."
                                value={controls.selectedForecast?.name}
                                addonBefore={<ForecastDomainIcon forecast={controls.selectedForecast} />}
                                addonAfter={
                                    <Icon
                                        type="folder-open"
                                        theme="twoTone"
                                        twoToneColor="#002b57"
                                        onClick={controls.onSelectModel}
                                    />
                                }
                            />
                        </div>
                        <Button type="primary" className="gmwo-header-btn gmwo-header-btn-browse" onClick={controls.onBrowseFiles} title="Browse files">
                            Browse Files
                        </Button>
                        <div className="gmwo-header-account">
                            <div className="gmwo-header-user">
                                {userIcon}
                                <span>{controls.userName}</span>
                                {controls.userCompany && <span className="gmwo-header-company">{controls.userCompany}</span>}
                            </div>
                            <Button type="primary" className="gmwo-header-btn gmwo-header-btn-logout" onClick={controls.onLogout} title="Logout">
                                Logout
                            </Button>
                        </div>
                    </>}
                </div>
            </div>
        </Header>
    );
}
